/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ManagerActivity } from '../model/managerActivity';
import { ManagerActivityStat } from '../model/managerActivityStat';
import { ManagerActivityTargetLink } from '../model/managerActivityTargetLink';
import { ManagerTarget } from '../model/managerTarget';
import { PaginatedManagerActivityList } from '../model/paginatedManagerActivityList';
import { PaginatedManagerActivityTargetLinkList } from '../model/paginatedManagerActivityTargetLinkList';
import { PaginatedManagerTargetList } from '../model/paginatedManagerTargetList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PortfolioService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start) ViewSet for managing activities in the teacher portfolio. This class is responsible for handling CRUD operations related to activities.
     * @param activityType * &#x60;course&#x60; - Kurz * &#x60;workshop&#x60; - Workshop * &#x60;training&#x60; - Školení * &#x60;seminar&#x60; - Seminář * &#x60;webinar&#x60; - Webinář * &#x60;conference&#x60; - Konference * &#x60;publication&#x60; - Publikační / lektorská činnost * &#x60;project&#x60; - Projektová činnost * &#x60;internship&#x60; - Stáže / praxe * &#x60;self_study&#x60; - Samostudium * &#x60;volunteering&#x60; - Dobrovolnická činnost * &#x60;other&#x60; - Jiné
     * @param dateEnd 
     * @param dateEndGte 
     * @param dateEndLte 
     * @param dateStart 
     * @param dateStartGte 
     * @param dateStartLte 
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param ordering Which field to use when ordering the results.
     * @param recommendToOthers 
     * @param search A search term.
     * @param selfPayer 
     * @param studyType * &#x60;in_person&#x60; - Prezenční * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Kombinované
     * @param teacherId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public portfolioActivitiesList(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, limit?: number, offset?: number, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedManagerActivityList>;
    public portfolioActivitiesList(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, limit?: number, offset?: number, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedManagerActivityList>>;
    public portfolioActivitiesList(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, limit?: number, offset?: number, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedManagerActivityList>>;
    public portfolioActivitiesList(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, limit?: number, offset?: number, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activityType !== undefined && activityType !== null) {
            queryParameters = queryParameters.set('activity_type', <any>activityType);
        }
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('date_end', <any>dateEnd);
        }
        if (dateEndGte !== undefined && dateEndGte !== null) {
            queryParameters = queryParameters.set('date_end__gte', <any>dateEndGte);
        }
        if (dateEndLte !== undefined && dateEndLte !== null) {
            queryParameters = queryParameters.set('date_end__lte', <any>dateEndLte);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('date_start', <any>dateStart);
        }
        if (dateStartGte !== undefined && dateStartGte !== null) {
            queryParameters = queryParameters.set('date_start__gte', <any>dateStartGte);
        }
        if (dateStartLte !== undefined && dateStartLte !== null) {
            queryParameters = queryParameters.set('date_start__lte', <any>dateStartLte);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (recommendToOthers !== undefined && recommendToOthers !== null) {
            queryParameters = queryParameters.set('recommend_to_others', <any>recommendToOthers);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (selfPayer !== undefined && selfPayer !== null) {
            queryParameters = queryParameters.set('self_payer', <any>selfPayer);
        }
        if (studyType !== undefined && studyType !== null) {
            queryParameters = queryParameters.set('study_type', <any>studyType);
        }
        if (teacherId !== undefined && teacherId !== null) {
            queryParameters = queryParameters.set('teacher_id', <any>teacherId);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedManagerActivityList>('get',`${this.basePath}/portfolio/activities/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start) ViewSet for managing activities in the teacher portfolio. This class is responsible for handling CRUD operations related to activities.
     * @param activityType * &#x60;course&#x60; - Kurz * &#x60;workshop&#x60; - Workshop * &#x60;training&#x60; - Školení * &#x60;seminar&#x60; - Seminář * &#x60;webinar&#x60; - Webinář * &#x60;conference&#x60; - Konference * &#x60;publication&#x60; - Publikační / lektorská činnost * &#x60;project&#x60; - Projektová činnost * &#x60;internship&#x60; - Stáže / praxe * &#x60;self_study&#x60; - Samostudium * &#x60;volunteering&#x60; - Dobrovolnická činnost * &#x60;other&#x60; - Jiné
     * @param dateEnd 
     * @param dateEndGte 
     * @param dateEndLte 
     * @param dateStart 
     * @param dateStartGte 
     * @param dateStartLte 
     * @param ordering Which field to use when ordering the results.
     * @param recommendToOthers 
     * @param search A search term.
     * @param selfPayer 
     * @param studyType * &#x60;in_person&#x60; - Prezenční * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Kombinované
     * @param teacherId 
     * @param type Export type: &#x27;csv&#x27; or &#x27;xlsx&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public portfolioActivitiesPrintRetrieve(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, type?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public portfolioActivitiesPrintRetrieve(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, type?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public portfolioActivitiesPrintRetrieve(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, type?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public portfolioActivitiesPrintRetrieve(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, type?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activityType !== undefined && activityType !== null) {
            queryParameters = queryParameters.set('activity_type', <any>activityType);
        }
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('date_end', <any>dateEnd);
        }
        if (dateEndGte !== undefined && dateEndGte !== null) {
            queryParameters = queryParameters.set('date_end__gte', <any>dateEndGte);
        }
        if (dateEndLte !== undefined && dateEndLte !== null) {
            queryParameters = queryParameters.set('date_end__lte', <any>dateEndLte);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('date_start', <any>dateStart);
        }
        if (dateStartGte !== undefined && dateStartGte !== null) {
            queryParameters = queryParameters.set('date_start__gte', <any>dateStartGte);
        }
        if (dateStartLte !== undefined && dateStartLte !== null) {
            queryParameters = queryParameters.set('date_start__lte', <any>dateStartLte);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (recommendToOthers !== undefined && recommendToOthers !== null) {
            queryParameters = queryParameters.set('recommend_to_others', <any>recommendToOthers);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (selfPayer !== undefined && selfPayer !== null) {
            queryParameters = queryParameters.set('self_payer', <any>selfPayer);
        }
        if (studyType !== undefined && studyType !== null) {
            queryParameters = queryParameters.set('study_type', <any>studyType);
        }
        if (teacherId !== undefined && teacherId !== null) {
            queryParameters = queryParameters.set('teacher_id', <any>teacherId);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/portfolio/activities/print/`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start) ViewSet for managing activities in the teacher portfolio. This class is responsible for handling CRUD operations related to activities.
     * @param id A UUID string identifying this activity.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public portfolioActivitiesRetrieve(id: string, observe?: 'body', reportProgress?: boolean): Observable<ManagerActivity>;
    public portfolioActivitiesRetrieve(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ManagerActivity>>;
    public portfolioActivitiesRetrieve(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ManagerActivity>>;
    public portfolioActivitiesRetrieve(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling portfolioActivitiesRetrieve.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ManagerActivity>('get',`${this.basePath}/portfolio/activities/${encodeURIComponent(String(id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Ordering options: created, modified, date_start, date_end (default: -date_start) ViewSet for managing activities in the teacher portfolio. This class is responsible for handling CRUD operations related to activities.
     * @param activityType * &#x60;course&#x60; - Kurz * &#x60;workshop&#x60; - Workshop * &#x60;training&#x60; - Školení * &#x60;seminar&#x60; - Seminář * &#x60;webinar&#x60; - Webinář * &#x60;conference&#x60; - Konference * &#x60;publication&#x60; - Publikační / lektorská činnost * &#x60;project&#x60; - Projektová činnost * &#x60;internship&#x60; - Stáže / praxe * &#x60;self_study&#x60; - Samostudium * &#x60;volunteering&#x60; - Dobrovolnická činnost * &#x60;other&#x60; - Jiné
     * @param dateEnd 
     * @param dateEndGte 
     * @param dateEndLte 
     * @param dateStart 
     * @param dateStartGte 
     * @param dateStartLte 
     * @param ordering Which field to use when ordering the results.
     * @param recommendToOthers 
     * @param search A search term.
     * @param selfPayer 
     * @param studyType * &#x60;in_person&#x60; - Prezenční * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Kombinované
     * @param teacherId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public portfolioActivitiesStatsRetrieve(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, observe?: 'body', reportProgress?: boolean): Observable<ManagerActivityStat>;
    public portfolioActivitiesStatsRetrieve(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ManagerActivityStat>>;
    public portfolioActivitiesStatsRetrieve(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ManagerActivityStat>>;
    public portfolioActivitiesStatsRetrieve(activityType?: string, dateEnd?: string, dateEndGte?: string, dateEndLte?: string, dateStart?: string, dateStartGte?: string, dateStartLte?: string, ordering?: string, recommendToOthers?: boolean, search?: string, selfPayer?: boolean, studyType?: string, teacherId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {














        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activityType !== undefined && activityType !== null) {
            queryParameters = queryParameters.set('activity_type', <any>activityType);
        }
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('date_end', <any>dateEnd);
        }
        if (dateEndGte !== undefined && dateEndGte !== null) {
            queryParameters = queryParameters.set('date_end__gte', <any>dateEndGte);
        }
        if (dateEndLte !== undefined && dateEndLte !== null) {
            queryParameters = queryParameters.set('date_end__lte', <any>dateEndLte);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('date_start', <any>dateStart);
        }
        if (dateStartGte !== undefined && dateStartGte !== null) {
            queryParameters = queryParameters.set('date_start__gte', <any>dateStartGte);
        }
        if (dateStartLte !== undefined && dateStartLte !== null) {
            queryParameters = queryParameters.set('date_start__lte', <any>dateStartLte);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (recommendToOthers !== undefined && recommendToOthers !== null) {
            queryParameters = queryParameters.set('recommend_to_others', <any>recommendToOthers);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (selfPayer !== undefined && selfPayer !== null) {
            queryParameters = queryParameters.set('self_payer', <any>selfPayer);
        }
        if (studyType !== undefined && studyType !== null) {
            queryParameters = queryParameters.set('study_type', <any>studyType);
        }
        if (teacherId !== undefined && teacherId !== null) {
            queryParameters = queryParameters.set('teacher_id', <any>teacherId);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ManagerActivityStat>('get',`${this.basePath}/portfolio/activities/stats/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * ViewSet for managing activities in the teacher portfolio. This class is responsible for handling CRUD operations related to activities.
     * @param activityId 
     * @param createdAt 
     * @param isChecked 
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param search A search term.
     * @param targetId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public portfolioActivityTargetLinksList(activityId?: string, createdAt?: Date, isChecked?: boolean, limit?: number, offset?: number, search?: string, targetId?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedManagerActivityTargetLinkList>;
    public portfolioActivityTargetLinksList(activityId?: string, createdAt?: Date, isChecked?: boolean, limit?: number, offset?: number, search?: string, targetId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedManagerActivityTargetLinkList>>;
    public portfolioActivityTargetLinksList(activityId?: string, createdAt?: Date, isChecked?: boolean, limit?: number, offset?: number, search?: string, targetId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedManagerActivityTargetLinkList>>;
    public portfolioActivityTargetLinksList(activityId?: string, createdAt?: Date, isChecked?: boolean, limit?: number, offset?: number, search?: string, targetId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activityId !== undefined && activityId !== null) {
            queryParameters = queryParameters.set('activity_id', <any>activityId);
        }
        if (createdAt !== undefined && createdAt !== null) {
            queryParameters = queryParameters.set('created_at', <any>createdAt.toISOString());
        }
        if (isChecked !== undefined && isChecked !== null) {
            queryParameters = queryParameters.set('is_checked', <any>isChecked);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (targetId !== undefined && targetId !== null) {
            queryParameters = queryParameters.set('target_id', <any>targetId);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedManagerActivityTargetLinkList>('get',`${this.basePath}/portfolio/activity-target-links/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * ViewSet for managing activities in the teacher portfolio. This class is responsible for handling CRUD operations related to activities.
     * @param id A UUID string identifying this activity target link.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public portfolioActivityTargetLinksRetrieve(id: string, observe?: 'body', reportProgress?: boolean): Observable<ManagerActivityTargetLink>;
    public portfolioActivityTargetLinksRetrieve(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ManagerActivityTargetLink>>;
    public portfolioActivityTargetLinksRetrieve(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ManagerActivityTargetLink>>;
    public portfolioActivityTargetLinksRetrieve(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling portfolioActivityTargetLinksRetrieve.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ManagerActivityTargetLink>('get',`${this.basePath}/portfolio/activity-target-links/${encodeURIComponent(String(id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * ViewSet for managing activities in the teacher portfolio. This class is responsible for handling CRUD operations related to activities.
     * @param created 
     * @param createdDateGte 
     * @param createdDateLte 
     * @param createdGte 
     * @param createdLte 
     * @param fulfillmentDate 
     * @param fulfillmentDateGte 
     * @param fulfillmentDateLte 
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param search A search term.
     * @param state V jakém stavu se cíl aktuálně nachází.  * &#x60;waiting&#x60; - Čeká * &#x60;in_process&#x60; - Probíhá * &#x60;finished&#x60; - Dokončeno * &#x60;incomplete&#x60; - Nedokončeno
     * @param supportType Jaká forma podpory je k naplnění cíle potřeba.  * &#x60;financial&#x60; - Finance * &#x60;material&#x60; - Materiál * &#x60;organizational&#x60; - Organizační
     * @param teacherId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public portfolioTargetsList(created?: Date, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, limit?: number, offset?: number, search?: string, state?: string, supportType?: string, teacherId?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedManagerTargetList>;
    public portfolioTargetsList(created?: Date, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, limit?: number, offset?: number, search?: string, state?: string, supportType?: string, teacherId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedManagerTargetList>>;
    public portfolioTargetsList(created?: Date, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, limit?: number, offset?: number, search?: string, state?: string, supportType?: string, teacherId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedManagerTargetList>>;
    public portfolioTargetsList(created?: Date, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, limit?: number, offset?: number, search?: string, state?: string, supportType?: string, teacherId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (created !== undefined && created !== null) {
            queryParameters = queryParameters.set('created', <any>created.toISOString());
        }
        if (createdDateGte !== undefined && createdDateGte !== null) {
            queryParameters = queryParameters.set('created__date__gte', <any>createdDateGte);
        }
        if (createdDateLte !== undefined && createdDateLte !== null) {
            queryParameters = queryParameters.set('created__date__lte', <any>createdDateLte);
        }
        if (createdGte !== undefined && createdGte !== null) {
            queryParameters = queryParameters.set('created__gte', <any>createdGte.toISOString());
        }
        if (createdLte !== undefined && createdLte !== null) {
            queryParameters = queryParameters.set('created__lte', <any>createdLte.toISOString());
        }
        if (fulfillmentDate !== undefined && fulfillmentDate !== null) {
            queryParameters = queryParameters.set('fulfillment_date', <any>fulfillmentDate);
        }
        if (fulfillmentDateGte !== undefined && fulfillmentDateGte !== null) {
            queryParameters = queryParameters.set('fulfillment_date__gte', <any>fulfillmentDateGte);
        }
        if (fulfillmentDateLte !== undefined && fulfillmentDateLte !== null) {
            queryParameters = queryParameters.set('fulfillment_date__lte', <any>fulfillmentDateLte);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }
        if (supportType !== undefined && supportType !== null) {
            queryParameters = queryParameters.set('support_type', <any>supportType);
        }
        if (teacherId !== undefined && teacherId !== null) {
            queryParameters = queryParameters.set('teacher_id', <any>teacherId);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedManagerTargetList>('get',`${this.basePath}/portfolio/targets/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * ViewSet for managing activities in the teacher portfolio. This class is responsible for handling CRUD operations related to activities.
     * @param created 
     * @param createdDateGte 
     * @param createdDateLte 
     * @param createdGte 
     * @param createdLte 
     * @param fulfillmentDate 
     * @param fulfillmentDateGte 
     * @param fulfillmentDateLte 
     * @param search A search term.
     * @param state V jakém stavu se cíl aktuálně nachází.  * &#x60;waiting&#x60; - Čeká * &#x60;in_process&#x60; - Probíhá * &#x60;finished&#x60; - Dokončeno * &#x60;incomplete&#x60; - Nedokončeno
     * @param supportType Jaká forma podpory je k naplnění cíle potřeba.  * &#x60;financial&#x60; - Finance * &#x60;material&#x60; - Materiál * &#x60;organizational&#x60; - Organizační
     * @param teacherId 
     * @param type Export type: &#x27;csv&#x27; or &#x27;xlsx&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public portfolioTargetsPrintRetrieve(created?: Date, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, search?: string, state?: string, supportType?: string, teacherId?: number, type?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public portfolioTargetsPrintRetrieve(created?: Date, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, search?: string, state?: string, supportType?: string, teacherId?: number, type?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public portfolioTargetsPrintRetrieve(created?: Date, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, search?: string, state?: string, supportType?: string, teacherId?: number, type?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public portfolioTargetsPrintRetrieve(created?: Date, createdDateGte?: string, createdDateLte?: string, createdGte?: Date, createdLte?: Date, fulfillmentDate?: string, fulfillmentDateGte?: string, fulfillmentDateLte?: string, search?: string, state?: string, supportType?: string, teacherId?: number, type?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {














        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (created !== undefined && created !== null) {
            queryParameters = queryParameters.set('created', <any>created.toISOString());
        }
        if (createdDateGte !== undefined && createdDateGte !== null) {
            queryParameters = queryParameters.set('created__date__gte', <any>createdDateGte);
        }
        if (createdDateLte !== undefined && createdDateLte !== null) {
            queryParameters = queryParameters.set('created__date__lte', <any>createdDateLte);
        }
        if (createdGte !== undefined && createdGte !== null) {
            queryParameters = queryParameters.set('created__gte', <any>createdGte.toISOString());
        }
        if (createdLte !== undefined && createdLte !== null) {
            queryParameters = queryParameters.set('created__lte', <any>createdLte.toISOString());
        }
        if (fulfillmentDate !== undefined && fulfillmentDate !== null) {
            queryParameters = queryParameters.set('fulfillment_date', <any>fulfillmentDate);
        }
        if (fulfillmentDateGte !== undefined && fulfillmentDateGte !== null) {
            queryParameters = queryParameters.set('fulfillment_date__gte', <any>fulfillmentDateGte);
        }
        if (fulfillmentDateLte !== undefined && fulfillmentDateLte !== null) {
            queryParameters = queryParameters.set('fulfillment_date__lte', <any>fulfillmentDateLte);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }
        if (supportType !== undefined && supportType !== null) {
            queryParameters = queryParameters.set('support_type', <any>supportType);
        }
        if (teacherId !== undefined && teacherId !== null) {
            queryParameters = queryParameters.set('teacher_id', <any>teacherId);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/portfolio/targets/print/`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * ViewSet for managing activities in the teacher portfolio. This class is responsible for handling CRUD operations related to activities.
     * @param id A UUID string identifying this target.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public portfolioTargetsRetrieve(id: string, observe?: 'body', reportProgress?: boolean): Observable<ManagerTarget>;
    public portfolioTargetsRetrieve(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ManagerTarget>>;
    public portfolioTargetsRetrieve(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ManagerTarget>>;
    public portfolioTargetsRetrieve(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling portfolioTargetsRetrieve.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ManagerTarget>('get',`${this.basePath}/portfolio/targets/${encodeURIComponent(String(id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
